import { Molecule } from 'AppReact'
import styled, { css } from 'styled-components'
import { ClickableIcon, Text, Tooltip } from 'atoms';
import { XSvg } from 'components/icons';
import { colorShade } from 'utils';
import { textEllipsis } from 'utils/ellipsis';
import { TooltipWrapper } from 'wrappers';

const template = styled.div`
  ${({ displayState }) => css`
    background-color: ${colorShade(0.9, displayState?.color ?? window?.settings?.primary_color ?? '#1DBD6B')};
    font-size: ${displayState?.fontSize ?? '14px'};
    padding: ${displayState?.padding ?? '4px 12px'};
    color:${displayState?.color ?? window?.settings?.primary_color ?? '#1DBD6B'};
    border-radius: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  `}
`

export default Molecule({
  template,
  atoms: [
    {
      wrapper: TooltipWrapper,
      name: '__transparent__',
      atoms: [
        {
          component: Text,
          name: 'Name',
          displayValue: ({ name }) => textEllipsis(name ?? '', 10),
        },
        {
          component: Tooltip,
          renderIf: ({ name }) => name?.length > 10,
          name: 'Popup',
          displayValue: ({ name }) => name ?? ''
        }
      ]
    },
    {
      component: ClickableIcon,
      name: 'Icon',
      displayValue: ({ color }) => XSvg({ width: 16, height: 16, color: colorShade(0.5, color ?? window?.settings?.primary_color ?? '#1DBD6B'), circle: true })
    }
  ]
})